import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import withAuth from '../../auth/WithAuth';
import './support.scss';
import FurnitureNavbar from '../../../components/layout/Nav';

const Support = () => {
  const [tickets, setTickets] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filters, setFilters] = useState({
    status: 'all',
    priority: 'all',
    category: 'all',
    search: ''
  });

  // Enhanced dummy support tickets data
  const dummyTickets = [
    {
      id: 'TCK-001',
      subject: 'Payment not processed for completed project',
      description: 'I completed the dining table project 3 days ago but haven\'t received payment. The client confirmed completion but the funds are still held in escrow.',
      user_name: 'John Kamau',
      user_email: 'john@example.com',
      user_type: 'artisan',
      status: 'open',
      priority: 'high',
      category: 'billing',
      created_at: '2025-01-20T14:30:00Z',
      updated_at: '2025-01-20T14:30:00Z',
      assigned_to: null,
      messages_count: 2,
      last_activity: '2 hours ago',
      project_reference: 'Custom Wooden Dining Table',
      attachments: ['receipt.pdf']
    },
    {
      id: 'TCK-002',
      subject: 'Unable to upload project images',
      description: 'When trying to upload reference images for my new project, I keep getting "File upload failed" error. I\'ve tried multiple image formats and sizes below 5MB.',
      user_name: 'Alice Smith',
      user_email: 'alice@example.com',
      user_type: 'client',
      status: 'in_progress',
      priority: 'medium',
      category: 'technical',
      created_at: '2025-01-20T10:15:00Z',
      updated_at: '2025-01-20T11:45:00Z',
      assigned_to: 'Support Agent',
      messages_count: 5,
      last_activity: '30 minutes ago',
      project_reference: 'Office Desk Setup',
      attachments: ['error_screenshot.png']
    },
    {
      id: 'TCK-003',
      subject: 'Account verification pending for too long',
      description: 'I submitted my artisan verification documents 5 days ago but my account is still showing as "pending verification". This is affecting my ability to bid on projects.',
      user_name: 'Sarah Wanjiku',
      user_email: 'sarah@example.com',
      user_type: 'artisan',
      status: 'open',
      priority: 'urgent',
      category: 'account',
      created_at: '2025-01-19T16:20:00Z',
      updated_at: '2025-01-20T09:10:00Z',
      assigned_to: null,
      messages_count: 1,
      last_activity: '1 day ago',
      project_reference: null,
      attachments: ['id_card.jpg', 'portfolio.pdf']
    },
    {
      id: 'TCK-004',
      subject: 'Wrong commission charged on project',
      description: 'The platform charged 7% commission instead of the advertised 5% on my completed metalwork project. Please review and refund the excess amount.',
      user_name: 'Mike Otieno',
      user_email: 'mike@example.com',
      user_type: 'artisan',
      status: 'resolved',
      priority: 'high',
      category: 'billing',
      created_at: '2025-01-18T11:45:00Z',
      updated_at: '2025-01-19T15:20:00Z',
      assigned_to: 'Finance Team',
      messages_count: 8,
      last_activity: '2 days ago',
      project_reference: 'Metal Security Gate',
      attachments: ['transaction_history.pdf']
    },
    {
      id: 'TCK-005',
      subject: 'How to extend project deadline?',
      description: 'I need to extend the deadline for my ongoing bookshelf project due to material delivery delays. Can you guide me through the process?',
      user_name: 'Dana White',
      user_email: 'dana@example.com',
      user_type: 'client',
      status: 'closed',
      priority: 'low',
      category: 'general',
      created_at: '2025-01-17T13:30:00Z',
      updated_at: '2025-01-18T10:15:00Z',
      assigned_to: 'Support Agent',
      messages_count: 4,
      last_activity: '3 days ago',
      project_reference: 'Bookshelf Unit',
      attachments: []
    },
    {
      id: 'TCK-006',
      subject: 'Artisan not responding to messages',
      description: 'The artisan assigned to my kitchen cabinet project has not responded to my messages for 4 days. The project deadline is approaching and I\'m concerned.',
      user_name: 'Fiona Gallagher',
      user_email: 'fiona@example.com',
      user_type: 'client',
      status: 'open',
      priority: 'medium',
      category: 'general',
      created_at: '2025-01-16T15:20:00Z',
      updated_at: '2025-01-20T08:45:00Z',
      assigned_to: null,
      messages_count: 3,
      last_activity: '4 hours ago',
      project_reference: 'Kitchen Cabinet Refacing',
      attachments: ['message_history.png']
    },
    {
      id: 'TCK-007',
      subject: 'Mobile app crashing on login',
      description: 'The mobile app crashes immediately after entering my login credentials. I\'ve tried reinstalling but the issue persists. Using Android version 12.',
      user_name: 'George Martin',
      user_email: 'george@example.com',
      user_type: 'client',
      status: 'in_progress',
      priority: 'high',
      category: 'technical',
      created_at: '2025-01-15T09:10:00Z',
      updated_at: '2025-01-20T12:30:00Z',
      assigned_to: 'Tech Support',
      messages_count: 6,
      last_activity: '1 hour ago',
      project_reference: null,
      attachments: ['crash_log.txt']
    },
    {
      id: 'TCK-008',
      subject: 'Request for partnership program information',
      description: 'I\'m interested in your artisan partnership program for established workshops. Can you provide details about benefits and requirements?',
      user_name: 'David Kimani',
      user_email: 'david@example.com',
      user_type: 'artisan',
      status: 'closed',
      priority: 'low',
      category: 'general',
      created_at: '2025-01-14T14:55:00Z',
      updated_at: '2025-01-15T16:40:00Z',
      assigned_to: 'Partnership Team',
      messages_count: 3,
      last_activity: '5 days ago',
      project_reference: null,
      attachments: ['workshop_portfolio.pdf']
    }
  ];

  useEffect(() => {
    // Simulate API fetch with loading state
    setTimeout(() => {
      setTickets(dummyTickets);
      setLoading(false);
    }, 1000);
  }, []);

  const filteredTickets = tickets.filter(ticket => {
    if (filters.status !== 'all' && ticket.status !== filters.status) return false;
    if (filters.priority !== 'all' && ticket.priority !== filters.priority) return false;
    if (filters.category !== 'all' && ticket.category !== filters.category) return false;
    if (filters.search && 
        !ticket.subject.toLowerCase().includes(filters.search.toLowerCase()) &&
        !ticket.user_name.toLowerCase().includes(filters.search.toLowerCase()) &&
        !ticket.description.toLowerCase().includes(filters.search.toLowerCase())) return false;
    return true;
  });

  const getStatusCount = (status) => tickets.filter(t => t.status === status).length;
  const getPriorityCount = (priority) => tickets.filter(t => t.priority === priority).length;
  const getCategoryCount = (category) => tickets.filter(t => t.category === category).length;

  const getStatusInfo = (status) => {
    const info = {
      'open': { color: '#f59e0b', icon: '🔓', label: 'Open' },
      'in_progress': { color: '#3b82f6', icon: '⚡', label: 'In Progress' },
      'resolved': { color: '#10b981', icon: '✅', label: 'Resolved' },
      'closed': { color: '#6b7280', icon: '🔒', label: 'Closed' }
    };
    return info[status] || { color: '#6b7280', icon: '❓', label: 'Unknown' };
  };

  const getPriorityInfo = (priority) => {
    const info = {
      'low': { color: '#10b981', icon: '💚', label: 'Low' },
      'medium': { color: '#f59e0b', icon: '💛', label: 'Medium' },
      'high': { color: '#ef4444', icon: '❤️', label: 'High' },
      'urgent': { color: '#dc2626', icon: '🚨', label: 'Urgent' }
    };
    return info[priority] || { color: '#6b7280', icon: '❓', label: 'Unknown' };
  };

  const getCategoryIcon = (category) => {
    const icons = {
      'technical': '🔧',
      'billing': '💰',
      'account': '👤',
      'general': '💬'
    };
    return icons[category] || '📁';
  };

  const handleStatusUpdate = (ticketId, newStatus) => {
    const updated = tickets.map(t => 
      t.id === ticketId ? { ...t, status: newStatus } : t
    );
    setTickets(updated);
  };

  const handleAssignToMe = (ticketId) => {
    const updated = tickets.map(t => 
      t.id === ticketId ? { ...t, assigned_to: 'You', status: 'in_progress' } : t
    );
    setTickets(updated);
  };

  const handleBulkAction = (action) => {
    alert(`Bulk action: ${action} selected`);
  };

  if (loading) {
    return (
      <div className="admin-support">
        <div className="page-header">
          <h1>🛟 Support Tickets</h1>
          <p>Manage customer support requests and inquiries</p>
        </div>
        <div className="loading-state">
          <div className="loading-spinner"></div>
          <p>Loading support tickets...</p>
        </div>
      </div>
    );
  }

  return (
   <>
   <FurnitureNavbar/>
    <div className="admin-support">
      <div className="page-header">
        <div className="header-content">
          <div className="header-text">
            <h1>🛟 Support Tickets</h1>
            <p>Manage customer support requests and inquiries</p>
          </div>
          <div className="header-actions">
            <button className="btn btn-primary" onClick={() => handleBulkAction('export')}>
              📊 Export Report
            </button>
          </div>
        </div>
      </div>

      {/* Enhanced Stats Overview */}
      <div className="stats-overview">
        <div className="stat-card total-tickets">
          <div className="stat-content">
            <div className="stat-icon">📨</div>
            <div className="stat-info">
              <h3>Total Tickets</h3>
              <p className="stat-value">{tickets.length}</p>
              <span className="stat-change positive">+8% this week</span>
            </div>
          </div>
        </div>

        <div className="stat-card open-tickets">
          <div className="stat-content">
            <div className="stat-icon">⏳</div>
            <div className="stat-info">
              <h3>Open</h3>
              <p className="stat-value">{getStatusCount('open')}</p>
              <span className="stat-change neutral">Needs attention</span>
            </div>
          </div>
        </div>

        <div className="stat-card high-priority">
          <div className="stat-content">
            <div className="stat-icon">🔴</div>
            <div className="stat-info">
              <h3>High Priority</h3>
              <p className="stat-value">{getPriorityCount('high') + getPriorityCount('urgent')}</p>
              <span className="stat-change negative">Urgent issues</span>
            </div>
          </div>
        </div>

        <div className="stat-card resolved-tickets">
          <div className="stat-content">
            <div className="stat-icon">✅</div>
            <div className="stat-info">
              <h3>Resolved</h3>
              <p className="stat-value">{getStatusCount('resolved')}</p>
              <span className="stat-change positive">+12% success rate</span>
            </div>
          </div>
        </div>
      </div>

      {/* Enhanced Filters */}
      <div className="filters-section">
        <div className="filters-bar">
          <div className="search-box">
            <input
              type="text"
              placeholder="Search tickets by subject, user, or description..."
              value={filters.search}
              onChange={(e) => setFilters(prev => ({ ...prev, search: e.target.value }))}
            />
            <span className="search-icon">🔍</span>
          </div>
          
          <div className="filter-group">
            <select 
              value={filters.status} 
              onChange={(e) => setFilters(prev => ({ ...prev, status: e.target.value }))}
            >
              <option value="all">All Status</option>
              <option value="open">Open</option>
              <option value="in_progress">In Progress</option>
              <option value="resolved">Resolved</option>
              <option value="closed">Closed</option>
            </select>
            
            <select 
              value={filters.priority} 
              onChange={(e) => setFilters(prev => ({ ...prev, priority: e.target.value }))}
            >
              <option value="all">All Priority</option>
              <option value="low">Low</option>
              <option value="medium">Medium</option>
              <option value="high">High</option>
              <option value="urgent">Urgent</option>
            </select>
            
            <select 
              value={filters.category} 
              onChange={(e) => setFilters(prev => ({ ...prev, category: e.target.value }))}
            >
              <option value="all">All Categories</option>
              <option value="technical">Technical</option>
              <option value="billing">Billing</option>
              <option value="account">Account</option>
              <option value="general">General</option>
            </select>
          </div>

          <div className="filter-actions">
            <button 
              className="btn btn-secondary" 
              onClick={() => setFilters({ status: 'all', priority: 'all', category: 'all', search: '' })}
            >
              Clear Filters
            </button>
            <span className="results-count">
              {filteredTickets.length} of {tickets.length} tickets
            </span>
          </div>
        </div>
      </div>

      {/* Tickets Section */}
      <div className="tickets-section">
        <div className="section-header">
          <h3>Support Tickets</h3>
          <div className="section-actions">
            <select 
              className="bulk-actions"
              onChange={(e) => handleBulkAction(e.target.value)}
              defaultValue=""
            >
              <option value="" disabled>Bulk Actions</option>
              <option value="assign">Assign to Me</option>
              <option value="close">Close Selected</option>
              <option value="export">Export Selected</option>
            </select>
          </div>
        </div>

        <div className="tickets-list">
          {filteredTickets.map(ticket => {
            const statusInfo = getStatusInfo(ticket.status);
            const priorityInfo = getPriorityInfo(ticket.priority);
            const categoryIcon = getCategoryIcon(ticket.category);
            
            return (
              <div key={ticket.id} className={`ticket-card ${ticket.status} ${ticket.priority}`}>
                <div className="ticket-header">
                  <div className="ticket-main-info">
                    <div className="ticket-id-section">
                      <span className="ticket-id">#{ticket.id}</span>
                      <span className="category-icon">{categoryIcon}</span>
                    </div>
                    <h3 className="ticket-subject">{ticket.subject}</h3>
                  </div>
                  
                  <div className="ticket-status-section">
                    <span 
                      className="priority-badge"
                      style={{ backgroundColor: priorityInfo.color }}
                    >
                      <span className="priority-icon">{priorityInfo.icon}</span>
                      {priorityInfo.label}
                    </span>
                    <span 
                      className="status-badge"
                      style={{ backgroundColor: statusInfo.color }}
                    >
                      <span className="status-icon">{statusInfo.icon}</span>
                      {statusInfo.label}
                    </span>
                  </div>
                </div>

                <div className="ticket-body">
                  <p className="ticket-description">{ticket.description}</p>
                  
                  <div className="ticket-meta">
                    <div className="user-info">
                      <div className="user-avatar">
                        {ticket.user_name?.charAt(0) || 'U'}
                      </div>
                      <div className="user-details">
                        <strong>{ticket.user_name}</strong>
                        <span>{ticket.user_email}</span>
                        <span className="user-type">{ticket.user_type}</span>
                      </div>
                    </div>
                    
                    <div className="ticket-details">
                      <div className="detail-item">
                        <span className="label">📅 Created</span>
                        <span className="value">{new Date(ticket.created_at).toLocaleDateString()}</span>
                      </div>
                      <div className="detail-item">
                        <span className="label">🕒 Last Activity</span>
                        <span className="value">{ticket.last_activity}</span>
                      </div>
                      {ticket.project_reference && (
                        <div className="detail-item">
                          <span className="label">📋 Project</span>
                          <span className="value project-ref">{ticket.project_reference}</span>
                        </div>
                      )}
                      {ticket.assigned_to && (
                        <div className="detail-item">
                          <span className="label">👤 Assigned To</span>
                          <span className={`value assignee ${ticket.assigned_to === 'You' ? 'you' : ''}`}>
                            {ticket.assigned_to}
                          </span>
                        </div>
                      )}
                    </div>
                  </div>

                  {ticket.attachments && ticket.attachments.length > 0 && (
                    <div className="ticket-attachments">
                      <span className="attachments-label">📎 Attachments:</span>
                      <div className="attachments-list">
                        {ticket.attachments.map((attachment, index) => (
                          <span key={index} className="attachment-tag">{attachment}</span>
                        ))}
                      </div>
                    </div>
                  )}
                </div>

                <div className="ticket-footer">
                  <div className="ticket-stats">
                    <span className="message-count">
                      💬 {ticket.messages_count} messages
                    </span>
                    <span className="ticket-age">
                      ⏱️ {new Date(ticket.created_at).toLocaleDateString() === new Date().toLocaleDateString() 
                        ? 'Today' 
                        : `${Math.floor((new Date() - new Date(ticket.created_at)) / (1000 * 60 * 60 * 24))} days ago`
                      }
                    </span>
                  </div>

                  <div className="ticket-actions">
                    <div className="primary-actions">
                      <Link 
                        to={`/admin/support/${ticket.id}`}
                        className="btn btn-outline view-btn"
                      >
                        👁️ View Details
                      </Link>
                      {!ticket.assigned_to || ticket.assigned_to !== 'You' ? (
                        <button 
                          className="btn btn-primary assign-btn"
                          onClick={() => handleAssignToMe(ticket.id)}
                        >
                          👤 Assign to Me
                        </button>
                      ) : (
                        <span className="assigned-to-you">✅ Assigned to You</span>
                      )}
                    </div>
                    
                    <div className="secondary-actions">
                      <select 
                        value={ticket.status}
                        onChange={(e) => handleStatusUpdate(ticket.id, e.target.value)}
                        className="status-select"
                      >
                        <option value="open">Open</option>
                        <option value="in_progress">In Progress</option>
                        <option value="resolved">Resolved</option>
                        <option value="closed">Closed</option>
                      </select>
                      <button className="btn btn-icon more-actions" title="More actions">
                        ⋮
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {filteredTickets.length === 0 && (
          <div className="empty-state">
            <div className="empty-icon">🛟</div>
            <h3>No support tickets found</h3>
            <p>No tickets match your current filter criteria. Try adjusting your search or filters.</p>
            <button 
              className="btn btn-primary"
              onClick={() => setFilters({ status: 'all', priority: 'all', category: 'all', search: '' })}
            >
              Clear All Filters
            </button>
          </div>
        )}
      </div>

      {/* Section Footer */}
      <div className="section-footer">
        <div className="footer-info">
          Showing {filteredTickets.length} of {tickets.length} tickets
        </div>
        <div className="pagination">
          <button className="page-btn" disabled>← Previous</button>
          <span className="page-info">Page 1 of 1</span>
          <button className="page-btn" disabled>Next →</button>
        </div>
      </div>
    </div>
   </>
  );
};

export default withAuth(Support, 'admin');